export const assignResourcesConfigureGantt = (gantt, generateColumns, assignHours) => {
  gantt.config.date_format = '%m-%d-%Y %H:%i';
  gantt.config.resource_property = 'owner';
  gantt.config.order_branch = true;
  gantt.config.open_tree_initially = true;
  gantt.config.resource = false;
  gantt.config.readonly = true;  // Makes the entire chart read-only

// If you want more granular control instead of complete readonly mode:
gantt.config.drag_create = false;  // Disable creating tasks by dragging
gantt.config.drag_move = false;    // Disable moving tasks
gantt.config.drag_resize = false;  // Disable resizing tasks
gantt.config.drag_links = false;   // Disable creating/modifying dependency links

// Disable the add/edit buttons in the lightbox
gantt.config.details_on_dblclick = false;  // Disable the lightbox on double click
gantt.config.show_quick_info = false;      // Disable the quick info popup

// Disable context menu for tasks
gantt.config.context_menu_enabled = false;

// If you're using the grid part of the gantt:
gantt.config.grid_readonly = true;  // Make the grid portion read-only

// Disable keyboard shortcuts for task manipulation
gantt.config.keyboard_navigation = true;  // Keep navigation
gantt.config.keyboard_navigation_cells = true;
gantt.attachEvent("onBeforeTaskSelected", function(id) {
  return true;  // Allow selection
});

gantt.attachEvent("onBeforeTaskDrag", function(id, mode, e) {
  return false;  // Prevent all drag operations
});

gantt.attachEvent("onBeforeLightbox", function(id) {
  return false;  // Prevent lightbox from opening
});
  gantt.config.lightbox = {
    sections: [
      { name: 'description', height: 38, map_to: 'text', type: 'textarea', focus: true },
      { name: 'resources', type: 'resources', map_to: 'auto', default_value: 8 },
      { name: 'time', type: 'duration', map_to: 'auto' },
    ],
  };
  gantt.templates.grid_row_class = (start, end, task) => {
    if (task.parent != 0) {
      return 'sub_task';
    } else {
      return 'parent_task';
    }
  };

  gantt.config.columns = [
    { name: 'text', tree: true, width: 200, resize: true },
    { name: 'start_date', align: 'center', width: 100, resize: true },
    {
      name: 'owner',
      align: 'center',
      width: 85,
      label: 'Owner',
      template: function (task) {
        if (task.type == gantt.config.types.project) {
          return '';
        }
        const resources = gantt.getTaskResources(task.id);
        if (!resources.length) {
          return 'Unassigned';
        } else if (resources.length === 1) {
          return resources[0].text;
        } else {
          return resources
            .map(function (resource) {
              return (
                "<div class='owner-label' title='" +
                resource.text +
                "'>" +
                resource.text.substr(0, 1) +
                '</div>'
              );
            })
            .join('');
        }
      },
      resize: true,
    },
    { name: 'duration', width: 60, resize: true, align: 'center' },
    { name: 'add', width: 44 },
  ];

  gantt.config.layout = {
    css: 'gantt_container',
    rows: [
      {
        cols: [
          { view: 'grid', group: 'grids', scrollY: 'scrollVer' },
          { resizer: true, width: 1 },
          { view: 'timeline', scrollX: 'scrollHor', scrollY: 'scrollVer' },
          { view: 'scrollbar', id: 'scrollVer', group: 'vertical' },
        ],
        gravity: 3,
      },
      // {resizer: true, width: 1},
      {
        cols: [
          {
            html: "<div class='text-center-gantt assign-resource-title lg-font'>Assign Resources</div>",
            css: 'resourse-grid-title-container',
            group: 'grids',
          },
          { resizer: true, width: 1 },
          {
            html: "<div class='text-center-gantt sm-font'><p>Note: You can assign Employees / Resources by selecting a specific date.Clicking on a date opens a form where you can assign resources.<br/> After assigning resources, you can input hours by clicking on each cell for a specific employee.</p></div>",
            css: '',
          },
        ],
        gravity: 0.6,
      },
      {
        config: {
          columns: [
            {
              name: 'name',
              label: 'Name',
              tree: true,
              template: function (resource) {
                return resource.text;
              },
            },
            {
              name: 'workload',
              align: 'center',
              label: 'Workload',
              template: function (resource) {
                var totalDuration = 0;
                if (resource.$role === 'task') {
                  gantt
                    .getResourceAssignments(resource.$resource_id, resource.$task_id)
                    .forEach(function (a) {
                      totalDuration += a.value * a.duration;
                    });
                } else {
                  gantt.ext.resources
                    .getSummaryResourceAssignments(resource.id)
                    .forEach(function (assignment) {
                      totalDuration += Number(assignment.value) * assignment.duration;
                    });
                }
                return (totalDuration || 0) + 'h';
              },
            },
          ],
        },
        cols: [
          { view: 'resourceGrid', group: 'grids', width: 435, scrollY: 'resourceVScroll' },
          { resizer: true, width: 1 },
          { view: 'resourceTimeline', scrollX: 'scrollHor', scrollY: 'resourceVScroll' },
          { view: 'scrollbar', id: 'resourceVScroll', group: 'vertical' },
        ],
        gravity: 2,
      },
      { view: 'scrollbar', id: 'scrollHor' },
    ],
  };

  gantt.config.resources = {
    editable_resource_diagram: true,
    dataprocessor_assignments: true,
  };

  gantt.locale.labels.section_resources = 'Owners';


    // console.log(
    //   JSON.stringify(
    //     {
    //       entity,
    //       action,
    //       data,
    //       id,
    //     },
    //     null,
    //     2
    //   )
    // );







    


    
  // gantt.createDataProcessor(function (entity, action, data, id) {
  //   gantt.config.readonly = true;
  //   return new Promise(async function (resolve, reject) {
  //     // assignHours(data);
  //     // var modes = gantt.config.drag_mode;
  //     // console.log(modes,"sadsavdgsadsgdsagdv")
  //     console.log(data,"what is coming")
  //     gantt.config.readonly = false;
  //     if (action === 'create') {
  //       const permanentId = `${entity}_${Math.round(Math.random() * 1000)}`;
  //       resolve({ id: permanentId });
  //     } else {
  //       resolve();
  //     }
  //   });
  // });
  const callback=()=>{
    // gantt.resetLightbox();
    // gantt.clearAll();
    // gantt.resetLayout();
    // gantt.render();
  }
  // var assignmentStore = gantt.getDatastore(gantt.config.resource_assignment_store);
 

  // assignmentStore.removeItem(assignment.id);
  // assignmentStore.updateItem(assignment.id);
   
  // gantt.updateTaskAssignments(taskId);

  
 gantt.createDataProcessor((function() {
    let lastLogTime = 0;
    const debounceTime = 300;
    // let number = 0;  // Keeps its state across function calls

    return function(entity, action, data, id) {
        gantt.config.readonly = true;

        return new Promise(async function(resolve, reject) {
            const currentTime = new Date().getTime();

            if (currentTime - lastLogTime > debounceTime) {
                console.log(data, "what is coming");

                // number++;  // Now, `number` maintains its value correctly
                lastLogTime = currentTime;

                // if (number < 2) {
                    // const onGantt = () => {
                    //     number = 0;  // Reset `number` correctly after operation
                    // };
                    assignHours(data, gantt);
                // }

                // console.log(number, "is handling");
            }

            gantt.config.readonly = false;

            if (action === 'create') {
                const permanentId = `${entity}_${Math.round(Math.random() * 1000)}`;
                resolve({ id: permanentId });
            } else {
                resolve();
            }
        });
    };
})());





};
